import { render, staticRenderFns } from "./pc-specs.vue?vue&type=template&id=5f347b2e&scoped=true&"
import script from "./pc-specs.vue?vue&type=script&lang=js&"
export * from "./pc-specs.vue?vue&type=script&lang=js&"
import style0 from "./pc-specs.vue?vue&type=style&index=0&id=5f347b2e&lang=scss&scoped=true&"
import style1 from "./pc-specs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f347b2e",
  null
  
)

export default component.exports